// removed by extract-text-webpack-plugin
module.exports = {"pi":"pi__3NiIq","file-upload":"file-upload__17Lj0"};


//////////////////
// WEBPACK FOOTER
// ./components/pi/style.less
// module id = Fm8M
// module chunks = 0